export const isCompleted = status => status === "COMPLETED";
export const isFailed = status => status === "FAILED";
export const isRunning = status => status === "RUNNING";
export const isCanceled = status => status === "CANCELED";